import {
  type ErrorResponse,
  postPayPointsPublicIDScan,
  type StartPayPointTransactionResponse,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { useMutation } from "@tanstack/react-query";

type Props = {
  onSuccess?: (data: StartPayPointTransactionResponse) => void;
  onError?: (error: ErrorResponse) => void;
};

type Parameters = {
  publicID: string;
  amount?: number;
  tipAmount?: number;
};

export const useScanPayPoint = ({ onSuccess, onError }: Props = {}) =>
  useMutation<StartPayPointTransactionResponse, ErrorResponse, Parameters>({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, amount, tipAmount }: Parameters) =>
        postPayPointsPublicIDScan(
          { amount, tipAmount: tipAmount ?? 0 },
          publicID,
        ),
    ),
    onSuccess,
    onError,
  });
